import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { AccessPermission, getDefaultAdminRoute } from '../../types/adminAccess';

interface ProtectedRouteProps {
  children: ReactNode;
  requireSuperAdmin?: boolean;
  requiredAccess?: AccessPermission;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireSuperAdmin = false, requiredAccess }) => {
  const { currentUser, isAdmin, isSuperAdmin, loading, adminProfile, hasAccess } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-600 border-t-transparent"></div>
      </div>
    );
  }

  if (!currentUser || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to={getDefaultAdminRoute(adminProfile)} replace />;
  }

  if (requiredAccess && !hasAccess(requiredAccess)) {
    return <Navigate to={getDefaultAdminRoute(adminProfile)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
